import {
    buildPageViewAttributes,
    getRoktConfig,
    getRoktConsent,
    initRokt,
    logPageView,
} from '@eventbrite/rokt-sdk';
import { Stage } from '@eventbrite/webapp-constants';
import { useEffect } from 'react';

let sdkInited = false;

export function RoktInit({ stage, apiKey }: { stage: Stage; apiKey?: string }) {
    useEffect(() => {
        if (!apiKey) {
            return;
        }

        const consent = getRoktConsent();
        if (consent.block) {
            return;
        }

        if (!sdkInited) {
            const isProd = stage === Stage.PROD;
            try {
                initRokt(getRoktConfig(isProd, apiKey), {
                    noFunctional: consent.noFunctional,
                    noTargeting: consent.noTargeting,
                });
                sdkInited = true;
            } catch (error) {
                console.error('Failed to initialize Rokt SDK:', error);
                return;
            }
        }

        logPageView(
            'home',
            buildPageViewAttributes({
                pageName: 'home',
                path: typeof window !== 'undefined' ? window.location.pathname : undefined,
            }),
        );
    }, [stage, apiKey]);

    return null;
}
